/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：218
 */

module.exports = {
  hide: "style_hide__3lU0N",
  "coco-widget-wrapper": "style_coco-widget-wrapper__1WaIH",
  "coco-child-widget": "style_coco-child-widget__1U4ZO",
  "coco-child-widget-selected": "style_coco-child-widget-selected__3qwpM",
  "coco-child-widget-full": "style_coco-child-widget-full__3naW2",
  buttonWidget: "style_buttonWidget__L3-zU",
  iconWrapper: "style_iconWrapper__3zrmg",
  textWrapper: "style_textWrapper__3x0Oo",
  text: "style_text__3gwqJ",
  input: "style_input__LKe4h",
  iconToTextLeftSpacing: "style_iconToTextLeftSpacing__15Uim",
  iconToTextRightSpacing: "style_iconToTextRightSpacing__VDrpI",
  transform: "style_transform__1mcmj",
  "transform-scale": "style_transform-scale__2f_Wy",
  contentEditable: "style_contentEditable__27qir"
}
